import { Button, Modal } from "react-bootstrap";
import close from "../../../Assets/Icons/close2.png";
import { useEffect, useState } from "react";
import "./BreakdownModal.css";

const BreakdownModal = ({ setShowBreakdownModal, selectedAddonData }) => {
    const [totalAddonOptionPrice, setTotalAddonOptionPrice] = useState(0)

    useEffect(()=> {
        const total = selectedAddonData.map((addon)=> addon.totalPrice).reduce((accumulator, currentValue)=> accumulator + currentValue, 0);
        setTotalAddonOptionPrice(total);
    }, [selectedAddonData]);
console.log("setShowBreakdownModal", selectedAddonData)
    return (
        <Modal
            show={true} // Always show the modal when this component is rendered
            onHide={() => setShowBreakdownModal(false)} // Close the modal when clicking outside or pressing Esc
            centered // Center the modal vertically and horizontally
            backdrop={true} // Enable backdrop (clicking outside will close the modal)
            keyboard={true} // Allow closing the modal with the Esc key
            dialogClassName="small-modal"
        >
            <Modal.Header className="d-flex align-items-center">
                <Modal.Title>
                    Selection breakdown
                </Modal.Title>
                <div className="close-btn" onClick={() => setShowBreakdownModal(false)}>
                    <img src={close} alt="close" />
                </div>
            </Modal.Header>

            <Modal.Body>
                <div>
                    {
                        selectedAddonData.map((addon) => (
                            <div className="mt-3">
                                <div className="addon-name">
                                    {addon.addOnName} x{addon.quantity} £{addon.addonTotalPrice}
                                </div>
                                <div className="ms-3 option-name">
                                    {addon.optionName} x{addon.optionQuantity} £{addon.optionTotalPrice}
                                </div>
                                <div className="ms-5 suboption-name">
                                    {addon.subOption?.name} x{addon.subOption?.quantity} £{addon.subOption?.price}
                                </div>
                                <div className="fw-bold">
                                    Total: £{addon.totalPrice}
                                </div>
                            </div>
                        ))
                    }

                    <div className="mt-4 fw-bold">
                        Total for addon and options: £{totalAddonOptionPrice}
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="success"
                    style={{
                        backgroundColor: "transparent",
                        color: "green",
                        fontWeight: "bold",
                    }}
                    onClick={() => setShowBreakdownModal(false)}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BreakdownModal;